function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export var getQueriesObjects = function getQueriesObjects(currentBreakpointName, breakpoints) {
  var currentBreakpoint = breakpoints.find(function (breakpoint) {
    return breakpoint.mediaType === currentBreakpointName;
  });
  var defaultQueryObject = {
    is: {},
    greaterThan: {},
    lessThan: {}
  };

  if (!currentBreakpoint) {
    return defaultQueryObject;
  }

  return breakpoints.reduce(function (memo, breakpoint) {
    var breakpointName = breakpoint.mediaType;
    return {
      is: _objectSpread(_objectSpread({}, memo.is), {}, _defineProperty({}, breakpointName, breakpointName === currentBreakpoint.mediaType)),
      greaterThan: _objectSpread(_objectSpread({}, memo.greaterThan), {}, _defineProperty({}, breakpointName, currentBreakpoint.greaterThan.includes(breakpointName))),
      lessThan: _objectSpread(_objectSpread({}, memo.lessThan), {}, _defineProperty({}, breakpointName, currentBreakpoint.lessThan.includes(breakpointName)))
    };
  }, defaultQueryObject);
};
export var getBreakpoints = function getBreakpoints(mediaQueries, breakpointNames) {
  return breakpointNames.map(function (breakpointName, index) {
    return {
      mediaType: breakpointName,
      mediaQuery: mediaQueries[breakpointName],
      greaterThan: breakpointNames.filter(function (_gtName, gtIndex) {
        return gtIndex < index;
      }),
      lessThan: breakpointNames.filter(function (_ltName, ltIndex) {
        return ltIndex > index;
      })
    };
  }, {});
};
export var getMediaqueries = function getMediaqueries(breakpoints, breakpointsMax, breakpointNames) {
  return breakpointNames.reduce(function (acc, breakpointName, index) {
    var nextBreakpointName = breakpointNames[index + 1];
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, breakpointName, "(min-width: ".concat(breakpoints[breakpointName], ")").concat(nextBreakpointName ? " and (max-width: ".concat(breakpointsMax[nextBreakpointName], ")") : '')));
  }, {
    _initial: '(min-width: 0em)'
  });
};